import { render, staticRenderFns } from "./searchShipping.vue?vue&type=template&id=5fb8c07c"
import script from "./searchShipping.vue?vue&type=script&lang=js"
export * from "./searchShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports